import Icon from '@components/icons';
import { IconsEnum } from '@components/icons/types';
import { socialMediaLinks } from '@screens/lp-default/components/footer/constants';
import * as Styles from '@screens/lp-default/components/footer/styles';

export default function SocialLinks() {
  return (
    <Styles.FooterSocials>
      {socialMediaLinks.map((link) => (
        <Styles.FooterSocialLink
          href={link.href}
          key={link.icon}
          target="_blank"
          rel="noreferrer"
          data-testid={link.icon}
        >
          <Icon icon={IconsEnum[link.icon]} size={20} />
        </Styles.FooterSocialLink>
      ))}
    </Styles.FooterSocials>
  );
}
